// @flow
import React, { Fragment } from 'react';
import { MdDelete, MdError } from 'react-icons/lib/md';
import { connect } from 'react-redux';

import Button from '../../Button';
import * as selectors from '../../../reducers';

import styles from './studentStopsCard.css';


type StudentStopsCardTypes = {
  stopName: string,
  stopShortName: string,
  routeShortName: string,
  onRemove: Function,
  alertTitle?: string,
};

const StudentStopAssignationCard = ({
  stopName,
  stopShortName,
  routeShortName,
  onRemove,
  alertTitle,
}: StudentStopsCardTypes) => (
  <td className={styles.studentStopsCard}>
    <div className={`${styles.column} ${styles.firstItem}`}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>
          {'Parada'}
          {' '}
          { routeShortName }
          { stopShortName }
        </div>
      </div>
      <div className={styles.subtitleContainer}>
        <div className={styles.subtitle}>
          { stopName }
        </div>
      </div>
      <div className={styles.alert}>
        {
          alertTitle && (
            <Fragment>
              <MdError size={20} />
              <span className={styles.alertTitle}>
                { alertTitle }
              </span>
            </Fragment>
          )
        }
      </div>
    </div>
    <div className={styles.column}>
      <Button
          className={styles.deleteButton}
          onClick={onRemove}
          size="small"
          clearMargins
          tint="gray"
          Icon={MdDelete}
          isTransparent
          isOutlined
        />
    </div>
  </td>
);


export default connect(
  (state, { stopId, occupiedDays }) => {
    const stop = selectors.getRouteStop(state, stopId);
    const route = selectors.getRoute(state, stop.route);

    return {
      stopName: stop.name,
      stopShortName: stop.short_name,
      routeShortName: route.short_name,
      alertTitle: route.week_days.filter(day => !occupiedDays.has(day)).length === 0
        ? 'Ya no hay espacio' : undefined,
    };
  },
  undefined,
)(StudentStopAssignationCard);



// WEBPACK FOOTER //
// ./src/scripts/components/StudentSchedulingPopup/StudentStopAssignationCard/index.jsx